module.exports = __webpack_public_path__ + "static/00039.cf58488c.jpg";